var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#085229;}\n\t.st1{fill:#FFFFFF;stroke:#005F20;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.5,241.9c15.5,17.6,37.4,28.3,60.8,29.7c13.9-0.7,26.9-6.7,36.6-16.6c19.1-16.4,39.2-31.6,60.1-45.6 l11.7-4.8c4.8-2.1,13.1-6.9,20.7-15.9c8.3-11.1,9.7-22.8,9.7-26.9c-0.9-13.1-5.2-25.7-12.4-36.6C228.4,193.5,157.8,237.5,79.5,241.9 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.8,45.7c10.4-11,24.9-17.3,40.1-17.3c9.6-0.6,19.1,2.6,26.2,9c19.8,14,43.4,21.7,67.7,22.1 c6.2,0.7,18.6,2.8,26.9,13.1c6.2,8.3,6.9,17.3,6.9,21.4c-0.6,10.7-2.9,21.2-6.9,31.1L105.8,45.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.5,241.9c-6.2-0.7-14.5-2.8-24.2-6.9c-9.7-4.1-21.4-9-29-22.1c-4.8-8.3-5.5-16.6-5.5-22.1 c0.2-14.7,3.7-29.1,10.4-42.1c6.6-16.1,11-33.1,13.1-50.4l3.5-13.8c2.1-6.9,3.5-13.8,8.3-20.7l7.6-8.3c12.5-7.9,27.4-11.3,42.1-9.7 C65.8,103,56,176.1,79.5,241.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.8,45.7c-0.7,0,37.3,2.1,60.8,10.4l19.3,8.3c-7.6-0.7-55.9-2.8-92.6,33.8c-46.3,47-31.1,111.2-30.4,114.7 c-10.7-13.5-16.1-30.4-15.2-47.7C49.6,119.1,70.6,75.7,105.8,45.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.4,216.4c26.7-48.6,21.8-108.4-12.4-152c20,3.3,38.4,13,52.5,27.6c8.3,6.9,18.6,17.3,28.3,33.2 C253.1,161.5,229.4,193.1,198.4,216.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.5,94.8c-11.1-18.6-26.9-26.9-33.8-30.4c-5.5-1.4-57.3-9.7-96.7,28.3c-31.8,30.4-33.8,69.8-33.8,77.4 c0.1,26,8.9,51.3,24.9,71.8c20.5,4,41.6,4,62.2,0c10.4-2.1,34.5-6.2,55.3-24.2c2.8-2.8,33.2-31.1,35.2-76 C233.6,134.2,233.6,114.8,220.5,94.8z M195.6,194.9c-13,14.1-31.3,22.1-50.4,22.1c-4.1,0-31.8-0.7-51.1-23.5 c-2.8-3.5-16.6-20-15.9-44.9c1.4-33.2,27.6-52.5,33.2-56.6c4.8-3.5,16.6-11.1,33.8-11.7c4.1-0.7,18.6-1.4,33.2,6.9 c31.8,17.3,33.2,58.7,33.2,61.5C211.5,156.3,211.5,177,195.6,194.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPax);
export default __webpack_public_path__ + "static/media/PAX.54388817be2c137277b8161f21cce8c5.svg";
export { ForwardRef as ReactComponent };